export function extractCompanyId(presignedURL: string) {
  const patientIdRegex = /(?<=\/company-)([\w-]*)(?=\/)/;
  const [id] = new URL(presignedURL).pathname.match(patientIdRegex) || [];
  return id;
}
